import { Component, h } from 'preact'
import axios, {AxiosResponse} from 'axios'
import FeaturedTopicView from './FeaturedTopicView'
import Button from '../ui-components/Button'

interface Author {
  id: number
  url: string
  name: string
  avatar: string
}

declare global {
  interface Window {
    inSidedData: {
      device: string
    }
  }
}

export interface Post {
  id: number
  author: Author
  content: string
  url: string
  creationDate: string
  relativeCreationDate: string
}

interface FeaturedTopic {
  id: number
  title: string
  description: string
  url: string
  type: string
  featuredImage: string
  label: string
  replyCount: number
  views: number
  post: Post
  customClass: string
}

interface Props {
  title: string
  topicsFullWidth: number
  topicIds: number[]
  buttonLabel?: string
  buttonUrl?: string
}

interface State {
  featuredTopics: FeaturedTopic[]
}

export default class FeaturedTopicsWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      featuredTopics: []
    }
  }

  async componentDidMount () {
    const { data }: AxiosResponse<{content: FeaturedTopic[]}> = await axios.get('/homepage/featuredTopics', {
      params: {
        topicIds: this.props.topicIds
      }
    })

    this.setState({
      featuredTopics: data.content
    })
  }

  render (
    { title, topicsFullWidth, topicIds, buttonLabel = '', buttonUrl = '' }: Props,
    { featuredTopics }: State
  ) {
    if (!topicIds || !topicIds.length) {
      return null
    }

    let customClass = ''

    const externalLink = buttonUrl && (buttonUrl.indexOf(window.location.hostname) < 0)

    return (
      <section class='featured-topics qa-featured-topics-container sitewidth'>
        {title &&
          <h2 class='featured-topics__heading'>{title}</h2>
        }
        <ul class='featured-topics__list'>
          { featuredTopics.map(({ title, featuredImage, label, replyCount, views, url, post }: FeaturedTopic, index: number) => {
            if (window.inSidedData?.device !== 'mobile' && index >= topicsFullWidth && ((featuredTopics.length - topicsFullWidth === 2) || (featuredTopics.length - topicsFullWidth === 4))) {
              customClass = 'featured-topic--half-width'
            }

            if (window.inSidedData?.device !== 'mobile' && index >= topicsFullWidth && (featuredTopics.length - topicsFullWidth === 1)) {
              customClass = 'featured-topic--full-width'
            }

            return (
              <FeaturedTopicView
                title={title}
                featuredImage={featuredImage}
                label={label}
                replyCount={replyCount}
                views={views}
                url={url}
                post={post}
                fullWidth={index < topicsFullWidth}
                customClass={customClass}
              />
          )})}
        </ul>
        {buttonLabel && buttonUrl &&
          <a
            class='featured-topics__show-more-button'
            href={buttonUrl}
            target={`${externalLink  ? '_blank' : '_self'}`}
            rel={`${externalLink ? 'noreferrer nofollow noopener' : ''}`}
          >
            <Button
              title={buttonLabel}
            />
          </a>
        }
      </section>
    )
  }
}
